import { CommonModule } from "@angular/common";
import { Component, Inject, Input, TemplateRef, ViewChild, signal } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatPaginatorIntl, MatPaginatorModule } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { MemberNotificationService } from "../../n-member/n-member.service";
import { IRequestResult } from "app/common/interfaces";
import NotificationMemberAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/notification-member.entity';
import NotificationGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-group/notification-group.entity';
import { IUpdateGroupNotification } from "../interfaces/group-interface";
import { GroupNotificationService } from "../n-group.service";
import { MatSelectModule } from "@angular/material/select";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import ShortNotificationMemberAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/short-notification-member/short-notification-member.short.entity";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";

@Component({
  selector: "app-ng-members",
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIcon,
    MatSortModule,
    MatButtonModule,
    FormsModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDialogModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatIconModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: "./ng-members.component.html",
  styleUrl: "./ng-members.component.scss",
  providers: [{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }],
})

export class NGMembersComponent {

  groupMembersList: ShortNotificationMemberAttributes[] = []
  public dataSourceMembers = new MatTableDataSource<any>([]);
  public displayedColumns: string[] = [
    "name",
    "email",
    "phone",
    "action"
  ];

  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof any = "name";
  sortDirection: "ASC" | "DESC" = "ASC";
  membersList: NotificationMemberAttributes[] = [];
  membersFilterList = signal<NotificationMemberAttributes[]>([]);
  searchMember = ''
  @ViewChild("orderConfirmationDialog")
  orderConfirmationDialog!: TemplateRef<any>;
  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;
  currentMemberMongoId: string = null;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private memberNotificationService: MemberNotificationService,
    private groupNotificationService: GroupNotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit(): void {
    this.initTable();
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    let searchAux = this.search.toLowerCase();
    let auxData = this.groupMembersList.slice()
    if (this.search && this.search != '') {
      const filtered = auxData.filter((element) => {
        const searchTerm = searchAux.toLowerCase();
        return (
          element.name?.toLowerCase().includes(searchTerm) ||
          element.email?.toString()?.toLowerCase().includes(searchTerm) ||
          element.phone?.toString()?.toLowerCase().includes(searchTerm)
        );
      });
      this.dataSourceMembers.data = filtered;
      return;
    } else {
      this.dataSourceMembers.data = auxData;
      return;
    }
  }

  /*
  initTable(){
    this.groupNotificationService.getMembersByGroupId(this.data._id.toString()).subscribe({
      next: (res: IRequestResult<ShortNotificationMemberAttributes[]>) => {
        this.groupMembersList = res.data;
        this.dataSourceMembers.data = res.data;
        this.membersFilterList.update(()=> this.membersList.slice());
      },
      error: (err) => {
      }
    });
  }*/
  initTable() {
    const companyId = this.data?.company?._id || this.data?.company?.id;
    if (!companyId) return;
    let activeMembers: NotificationMemberAttributes[] = [];
    this.memberNotificationService.getCombo({ companyId }).subscribe({
      next: (res: IRequestResult<NotificationMemberAttributes[]>) => {
        activeMembers = res.data; // solo statusId === 1
        // Solo hacer la segunda consulta si hay miembros activos
        if (activeMembers.length > 0) {
          this.getMembersByGroupId(activeMembers);
        } else {
          this.groupMembersList = [];
          this.dataSourceMembers.data = [];
        }
      },
      error: (err) => this.snackBar.open(err.error.message || "Error al obtener miembros activos.", "Cerrar", { duration: 5000 })
    });
  }

  getMembersByGroupId(activeMembers: NotificationMemberAttributes[]) {
    this.groupNotificationService.getMembersByGroupId(this.data._id.toString()).subscribe({
      next: (resGroup: IRequestResult<ShortNotificationMemberAttributes[]>) => {
        // Solo dejamos en la tabla los miembros activos
        this.groupMembersList = resGroup.data.filter(memberInGroup =>
          activeMembers.some(m => m._id === memberInGroup._id)
        );
        this.dataSourceMembers.data = this.groupMembersList;
      },
      error: (err) => this.snackBar.open(err.error.message || "Error al obtener grupo de miembros", "Cerrar", { duration: 5000 })
    });
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.initTable()
  }

  getAllMembers(): void {
    const companyId = this.data?.company?._id || this.data?.company?.id;
    if (!companyId) return;
    const dataToFilter = { companyId };
    this.memberNotificationService.getCombo(dataToFilter).subscribe({
      next: (res: IRequestResult<NotificationMemberAttributes[]>) => {
        this.membersList = res.data;
        this.membersFilterList.update(() => this.membersList.slice());
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener miembros.", "Cerrar", { duration: 5000 });
      }
    });
  }

  changueOptionsMember(event) {
    if (!this.membersList) {
      return;
    }
    let search = event;
    if (!search) {
      this.membersFilterList.update(() => this.membersList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.membersFilterList.update(() => this.membersList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1))
  }

  openConfirmationDialog(): void {

    this.dialog
      .open(this.orderConfirmationDialog, {
        data: null,
        panelClass: "form-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result);
  }

  addMembers(): void {
    this.getAllMembers();
    this.dialogRef = this.dialog.open(this.actionModal, { width: '350px', disableClose: true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }

  onSubmit() {
    let membersAux = this.dataSourceMembers.data.slice();
    let membersToUpdate = membersAux.map(m => m._id.toString());
    if (membersToUpdate.filter((m) => m == this.currentMemberMongoId).length > 0) {
      this.snackBar.open('El correo ya existe en la lista.', 'Cerrar', { duration: 3000 });
      return;
    }
    membersToUpdate.push(this.currentMemberMongoId);
    const updateGroupNotification: IUpdateGroupNotification = {
      members: membersToUpdate,
      companyId: this.data.company._id,
      name: this.data.name,
      statusId: this.data.statusId
    }
    this.groupNotificationService.update(this.data._id.toString(), updateGroupNotification).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
        if (this.dialogRef) {
          this.dialogRef.close(true);
        }
        this.initTable();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  openDeleteDialog(member: ShortNotificationMemberAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: member, panelClass: "delete-modal", disableClose: true })
      .afterClosed()
      .subscribe((result) => result && this.delete(member)); // Pasar member, no index
  }

  /*delete(index){
    let membersAux = this.dataSourceMembers.data;
    membersAux.splice(index, 1);

    const updateGroupNotification: IUpdateGroupNotification = {
      members: membersAux.map(m => m._id),
      companyId: this.data.company._id,
      name: this.data.name,
      statusId: this.data.statusId
    }

    this.groupNotificationService.update(this.data._id.toString(), updateGroupNotification).subscribe({
      next: () => {
        this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
        if(this.dialogRef){
          this.dialogRef.close(true);
        }
        this.initTable();
        this.currentMemberMongoId = null;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
      }
    });

  }*/
  delete(member: ShortNotificationMemberAttributes) {
    // Encontrar el índice real del miembro en el array
    const memberIndex = this.dataSourceMembers.data.findIndex(m => m._id === member._id);
    if (memberIndex === -1) {
      this.snackBar.open('Error: Miembro no encontrado', 'Cerrar', { duration: 3000 });
      return;
    }
    // Crear nueva lista sin el miembro eliminado
    const membersAux = this.dataSourceMembers.data.filter(m => m._id !== member._id);
    const updateGroupNotification: IUpdateGroupNotification = {
      members: membersAux.map(m => m._id),
      companyId: this.data.company._id,
      name: this.data.name,
      statusId: this.data.statusId
    };
    this.groupNotificationService.update(this.data._id.toString(), updateGroupNotification).subscribe({
      next: () => {
        this.snackBar.open('Miembro eliminado con éxito', 'Cerrar', { duration: 3000 });
        this.initTable(); // Recargar la tabla
        this.currentMemberMongoId = null;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al eliminar el miembro', 'Cerrar', { duration: 3000 });
      }
    });
  }

}

